<div class="demo-container">
  <div class="demo-title" [innerHTML]="'demo_Data1' |i18n"></div>
  <div class="folder-container">

    <div class="folder" [ngClass]="{'hiding': requesting}">
      <div class="description" [innerHTML]="'demo_Data2' | i18n"></div>
      <button class="btn request" [innerHTML]="'demo_Data3' | i18n" (click)="request()"></button>
    </div>

    <div class="request-folder" [ngClass]="{'showing': isHidden}">
      <form [formGroup]="demoForm" (ngSubmit)="submitForm()">
        <div *ngIf="!contacted">
          <div class="form-title" [innerHTML]="'demo_Data4' | i18n"></div>
          <div class="form-group inputs" [ngClass]="{ 'invalid-check': formSubmitted && demoForm.get('name').invalid }">
            <input class="input" type="text" id="name" formControlName="name" required
              placeholder="{{ 'demo_Data5' | i18n: translationModes.PLACEHOLDER }}">
            <div class="required-invalid" *ngIf="formSubmitted && demoForm.get('name').invalid"
              [innerHTML]="'demo_Data12' | i18n"></div>
          </div>
          <div class="form-group inputs" [ngClass]="{ 'invalid-check': formSubmitted && demoForm.get('email').invalid || emailUsed }">
            <input class="input" type="email" id="email" formControlName="email" required
              placeholder="{{ 'demo_Data6' | i18n: translationModes.PLACEHOLDER }}">
            <div class="required-invalid" *ngIf="formSubmitted && demoForm.get('email').invalid"
              [innerHTML]="'demo_Data12' | i18n"></div>
            <div class="required-invalid" *ngIf="emailUsed" [innerHTML]="'demo_Data13' | i18n"></div>
          </div>
          <div class="form-group checkbox"
            [ngClass]="{ 'invalid-check-1': formSubmitted && demoForm.get('termsAndConditions').invalid }">
            <input type="checkbox" formControlName="termsAndConditions">
            <div class="tos">
              <div [innerHTML]="'demo_Data7' | i18n"></div>
              <a [href]="getRouterLink('TermsOfUse')" target="_blank" [innerHTML]="'demo_Data8' | i18n"></a>
            </div>
          </div>
          <div class="form-group checkbox last-checkbox">
            <input type="checkbox" formControlName="receiveCommunications">
            <div [innerHTML]="'demo_Data9' | i18n"></div>
          </div>
        </div>
        <div *ngIf="contacted" [innerHTML]="'demo_Data10' | i18n" class="contacted"></div>
        <div class="form-group flex">
          <button class="btn" type="submit" [innerHTML]="(contacted ? 'demo_Data11' : 'demo_Data3') | i18n"></button>
        </div>
      </form>
    </div>

  </div>
</div>
